import { Visibility, VisibilityOff } from '@mui/icons-material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useUtilities from '../../hooks/useUtilities';
import { IconTextField } from '../shared/ReusableSmallComponents';
// * ways to add extra space if we have a helperText: finally I removed only fixed height, without using those methods
// ? 1
// import { makeStyles } from '@mui/styles';
// const useStyles = makeStyles(() => ({
//     root: {
//         '& .MuiFormHelperText-root': {
//             paddingBottom: 50, // add extra space
//             marginBottom: 50, // add extra space
//         },
//     },
// }));
// inside the component :
//     const classes = useStyles();
// className={classes.root}
// ? 2
// helperText={<span style={{ marginBottom: '80px' }}>{passwordError}</span>}
const PASSWORD_COMMON_MESSAGE = 'Votre mot de passe très faible et commun, nous vous recommandons d\'en choisir un autre';
const PASSWORD_WEAK_MESSAGE = 'Votre mot de passe n\'est pas valide. Il doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial. Il doit également comporter au moins 8 caractères.';
const PASSWORDS_DIFF_MESSAGE = 'Les mots de passe saisis ne sont pas identiques';
const getMessageErrorOfPasswordInput = (passwordError,isConfirmationPassword) => {
    if(isConfirmationPassword){
        if(passwordError=='PASSWORDS_DIFF'){
            return PASSWORDS_DIFF_MESSAGE;
        }
    }
    else{
        if(passwordError=='PASSWORD_COMMON'){
            return PASSWORD_COMMON_MESSAGE;
        }
        else if(passwordError=='PASSWORD_WEAK'){
            return PASSWORD_WEAK_MESSAGE;
        }
    }
};
const PasswordInput = ({ isPasswordShown, togglePassword, password, setPassword,
    isPasswordValid, passwordError,isConfirmationPassword,name, ...props}) => {
    PasswordInput.propTypes = {
        isPasswordShown: PropTypes.any,
        togglePassword: PropTypes.func,
        name: PropTypes.any,
        password: PropTypes.any,
        setPassword: PropTypes.func,
        isPasswordValid: PropTypes.bool,
        isConfirmationPassword: PropTypes.bool,
        passwordError: PropTypes.any,
    };
    const { errors, showErrors } =useUtilities();
    const error = name in errors ? errors[name] : undefined;
    const { i18n } = useTranslation();

    return (
        <IconTextField
            {...props}
            type={isPasswordShown ? 'text' : 'password'}
            // label="Nouveau mot de passe*"
            autoComplete='new-password'
            // autoComplete='off'
            name={name ?? 'password'}
            iconEnd={isPasswordShown
                ? <VisibilityOff onClick={togglePassword} />
                : <Visibility onClick={togglePassword} />}
            onChange={e => {
                setPassword(e.target.value,);
            }}
            // sx={{
            //     width: '430px'
            // }}
            value={password}
            error={(!isPasswordValid && password != '') || (!!error && showErrors)}
            helperText={i18n.t(getMessageErrorOfPasswordInput(passwordError,isConfirmationPassword)) || (showErrors && (error?? ''))}
        />
    );
};

export default PasswordInput;